import styled from "styled-components";
import MatchStat from "./MatchStat";
import { calculateTeamStats } from "../../../utils/calculateTeamStats";
import { FC } from "react";
import { Fixture } from "../../../models/fixture";
import { Team } from "../../../models/team";
import defaultBadge from "../../../images/common/vgc-logo.png"
import Pitch from "../lineup/Pitch";

interface Props {
  fixture: Fixture
  team: Team 
  displayHomeLineup: boolean
}

const ScoreCardReverse: FC<Props> = ({ fixture, team, displayHomeLineup }) => {

  return (
    <>
        <Container>
         <Pitch lineupPositions={ displayHomeLineup ? fixture.lineupHome : fixture.lineupAway }></Pitch>
        </Container>
    </>
  );
};

export default ScoreCardReverse;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 85vw;
  max-width: 370px;
  padding: 0 0.5rem;
  margin: 0 auto;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;
